module.exports = __webpack_public_path__ + "img/4.296990b1.png";